import { connect } from 'react-redux';
import { Instances } from '../../../../constants';
import { IStateType } from '../../../../store/models/root.interface';
import {
	closeSideBar,
	getIsOpen,
    getParams,
} from '../../../../store/sidebar';
import LowBalanceAlertConfig, {
	DispatchPropsType,
	MapStatePropsType,
} from '../organisms/LowBalanceAlert/LowBalanceAlertConfig';
import { requestObject } from '../../../../store/Object';
import { updateObjects } from '../../../../store/Objects';

const mapStateToProps = (state: IStateType) => ({

	sidebarVisibility: getIsOpen(state),
    params: getParams(state),
});

const mapDispatchToProps = {

	onClose: () => {
		return closeSideBar();
	},
	onLoad: () => requestObject(Instances.NotificationAlerts, {}, undefined),
	onSave: (data: any, callBack: any) =>
		updateObjects(
			Instances.UpdateLowBalanceAlert,
			'POST',
			data,
			{},
			undefined,
			undefined,
			undefined,
			undefined,
			callBack
		),
};

export default connect<MapStatePropsType, DispatchPropsType, unknown, IStateType>(
	mapStateToProps,
	mapDispatchToProps
)(LowBalanceAlertConfig);
